/**
 * External dependencies
 */

/**
 * WordPress dependencies
 */
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */

export default function save() {
	return (
		<div { ...useBlockProps.save() } >
			<InnerBlocks.Content />
		</div>
	);
}
